// Menü einer Opportunity (Karte im Board, Zeile in der Liste): Lead öffnen, Bearbeiten, Status wechseln.
import type { OpportunityStatus } from "../api";
import type { OpportunityZeile } from "../api/opportunities";
import { Icon } from "../components/Icon";
import type { MenuePunkt } from "../components/Menue";

interface Eingabe {
  opp: OpportunityZeile;
  /** alle Status der Pipeline der Opportunity, in Reihenfolge */
  statuses: OpportunityStatus[];
  darfAendern: boolean;
  onOeffnen: () => void;
  onBearbeiten: () => void;
  onStatus: (statusId: string) => void;
}

export function opportunityMenue({ opp, statuses, darfAendern, onOeffnen, onBearbeiten, onStatus }: Eingabe): MenuePunkt[] {
  const punkte: MenuePunkt[] = [
    { label: "Lead öffnen", icon: "pfeil-rechts", onClick: onOeffnen },
    { label: "Bearbeiten", icon: "stift", onClick: onBearbeiten, deaktiviert: !darfAendern, hinweis: darfAendern ? undefined : "Dafür fehlt dir die Berechtigung (fremde Opportunity)." },
  ];
  if (statuses.length) {
    punkte.push({ label: "Status ändern", ueberschrift: true, trenner: true });
    for (const st of statuses) {
      const aktuell = st.id === opp.status_id;
      punkte.push({
        label: st.label,
        onClick: () => onStatus(st.id),
        deaktiviert: aktuell || !darfAendern,
        rechts: aktuell ? <Icon name="haken" groesse={14} /> : undefined,
      });
    }
  }
  return punkte;
}
